// Player names, shirt numbers and formations reproduce the pitch designs.
export const PSG_PLAYERS = [
    {
        image: "player-desire-doue",
        name: "DÉSIRÉ DOUÉ",
        number: 14,
        x: 217,
        y: 36,
        width: 126.515,
        portraitX: 14.1,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 78.197,
        numberY: 7.007,
        numberW: 24,
        numberH: 16,
        numberFont: 12.1,
        numberFace: "Staff Wide",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-fabian-ruiz",
        name: "FABIÁN RUIZ",
        number: 8,
        x: 269,
        y: 153,
        width: 126.515,
        portraitX: 14.1,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 84,
        numberY: 7,
        numberW: 18,
        numberH: 15,
        numberFont: 12,
        numberFace: "Staff Wide",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-nuno-mendes",
        name: "NUNO MENDES",
        number: 25,
        x: 122.975,
        y: 278.457,
        width: 165.026,
        portraitX: 18.39,
        size: 128.072,
        labelY: 101.626,
        labelH: 31.7,
        font: 20,
        numberX: 103.025,
        numberY: 9.543,
        numberW: 36,
        numberH: 21,
        numberFont: 16,
        numberFace: "Staff Wide",
        markerX: 74.303,
        markerY: 139.326,
        markerSize: 16.419,
    },
    {
        image: "player-ferran",
        name: "FERRAN",
        number: 9,
        x: 406,
        y: 63,
        width: 126.515,
        portraitX: 14.099,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 84.197,
        numberY: 7.007,
        numberW: 18,
        numberH: 16,
        numberFont: 12.1,
        numberFace: "Staff Wide",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-maghnes-akliouche",
        name: "MAGHNES AKLIOUCHE",
        number: 11,
        x: 408,
        y: 175,
        width: 126.515,
        portraitX: 14.099,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 83,
        numberY: 7,
        numberW: 19,
        numberH: 15,
        numberFont: 12,
        numberFace: "Staff Wide",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-marquinhos",
        name: "MARQUINHOS",
        number: 5,
        x: 304,
        y: 278.457,
        width: 165.026,
        portraitX: 18.39,
        size: 128.072,
        labelY: 101.626,
        labelH: 31.7,
        font: 20,
        numberX: 111,
        numberY: 9.543,
        numberW: 23,
        numberH: 21,
        numberFont: 16,
        numberFace: "Staff Wide",
        markerX: 74.303,
        markerY: 139.326,
        markerSize: 16.419,
    },
    {
        image: "player-ousmane-dembele",
        name: "OUSMANE DEMBÉLÉ",
        number: 10,
        x: 587,
        y: 36,
        width: 126.515,
        portraitX: 14.1,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 78.197,
        numberY: 7.007,
        numberW: 24,
        numberH: 16,
        numberFont: 12.1,
        numberFace: "Staff Wide",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-vitinha",
        name: "VITINHA",
        number: 17,
        x: 546.561,
        y: 153,
        width: 126.515,
        portraitX: 14.1,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 79.439,
        numberY: 7,
        numberW: 23,
        numberH: 15,
        numberFont: 12,
        numberFace: "Staff Wide",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-lucas-beraldo",
        name: "LUCAS BERALDO",
        number: 4,
        x: 485.025,
        y: 278.457,
        width: 165.026,
        portraitX: 18.39,
        size: 128.072,
        labelY: 101.626,
        labelH: 31.7,
        font: 20,
        numberX: 109.975,
        numberY: 9.543,
        numberW: 24,
        numberH: 21,
        numberFont: 16,
        numberFace: "Staff Wide",
        markerX: 74.303,
        markerY: 139.326,
        markerSize: 16.419,
    },
    {
        image: "player-achraf-hakimi",
        name: "ACHRAF HAKIMI",
        number: 2,
        x: 666.051,
        y: 278.457,
        width: 165.026,
        portraitX: 18.39,
        size: 128.072,
        labelY: 101.626,
        labelH: 31.7,
        font: 20,
        numberX: 110.949,
        numberY: 9.543,
        numberW: 23,
        numberH: 21,
        numberFont: 16,
        numberFace: "Staff Wide",
        markerX: 74.303,
        markerY: 139.326,
        markerSize: 16.419,
    },
    {
        image: "player-matvey-safonov",
        name: "MATVEY SAFONOV",
        number: 39,
        x: 400,
        y: 424,
        width: 140,
        portraitX: 4.999,
        size: 129.909,
        labelY: 103,
        labelH: 32,
        font: 20,
        numberX: 94.205,
        numberY: 6.343,
        numberW: 31,
        numberH: 26,
        numberFont: 20,
        numberFace: "Insatiable Display",
        markerX: 61.672,
        markerY: 141.106,
        markerSize: 16.655,
    },
];
export const MARSEILLE_PLAYERS = [
    {
        image: "player-conrad-jaden-egan-riley",
        name: "CONRAD JADEN EGAN-RILEY",
        number: 4,
        x: 186.539,
        y: 106,
        width: 163.436,
        portraitX: 32.561,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 105.461,
        numberY: 6,
        numberW: 18,
        numberH: 21,
        numberFont: 16,
        numberFace: "Insatiable Display",
        markerX: 75.424,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-jeffrey-de-lange",
        name: "JEFFREY DE LANGE",
        number: 1,
        x: 406,
        y: 38,
        width: 126.515,
        portraitX: 14.099,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 90,
        numberY: 6,
        numberW: 15,
        numberH: 21,
        numberFont: 16,
        numberFace: "Insatiable Display",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-bamo-meite",
        name: "BAMO MEÏTÉ",
        number: 18,
        x: 349,
        y: 138,
        width: 126.515,
        portraitX: 14.099,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 83,
        numberY: 6,
        numberW: 22,
        numberH: 21,
        numberFont: 16,
        numberFace: "Insatiable Display",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-timothy-weah",
        name: "TIMOTHY WEAH",
        number: 22,
        x: 483.516,
        y: 138,
        width: 126.515,
        portraitX: 14.1,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 79.439,
        numberY: 6,
        numberW: 25,
        numberH: 21,
        numberFont: 16,
        numberFace: "Insatiable Display",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-himad-abdelli",
        name: "HIMAD ABDELLI",
        number: 8,
        x: 255,
        y: 207,
        width: 126.515,
        portraitX: 14.099,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 87,
        numberY: 6,
        numberW: 18,
        numberH: 21,
        numberFont: 16,
        numberFace: "Insatiable Display",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-ulisses-garcia",
        name: "ULISSES GARCIA",
        number: 25,
        x: 621,
        y: 106,
        width: 126.515,
        portraitX: 14.1,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 80.439,
        numberY: 6,
        numberW: 24,
        numberH: 21,
        numberFont: 16,
        numberFace: "Insatiable Display",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-tochukwu-nnadi",
        name: "TOCHUKWU NNADI",
        number: 6,
        x: 413.835,
        y: 248,
        width: 119.356,
        portraitX: 6.566,
        size: 106.079,
        labelY: 84.174,
        labelH: 26.256,
        font: 16.56546401977539,
        numberX: 86.807,
        numberY: 5.42,
        numberW: 18,
        numberH: 21,
        numberFont: 16.565,
        numberFace: "Insatiable Display",
        markerX: 52.878,
        markerY: 115.4,
        markerSize: 13.6,
    },
    {
        image: "player-neal-maupay",
        name: "NEAL MAUPAY",
        number: 11,
        x: 131,
        y: 248,
        width: 136.687,
        portraitX: 15.232,
        size: 106.079,
        labelY: 84.174,
        labelH: 26.256,
        font: 16.56546401977539,
        numberX: 93.473,
        numberY: 5.42,
        numberW: 20,
        numberH: 21,
        numberFont: 16.565,
        numberFace: "Insatiable Display",
        markerX: 61.543,
        markerY: 115.4,
        markerSize: 13.6,
    },
    {
        image: "player-angel-gomes",
        name: "ANGEL GOMES",
        number: 7,
        x: 572,
        y: 207,
        width: 126.515,
        portraitX: 14.1,
        size: 98.185,
        labelY: 77.91,
        labelH: 24.302,
        font: 16,
        numberX: 87.439,
        numberY: 6,
        numberW: 17,
        numberH: 21,
        numberFont: 16,
        numberFace: "Insatiable Display",
        markerX: 56.964,
        markerY: 106.813,
        markerSize: 12.588,
    },
    {
        image: "player-amine-gouiri",
        name: "AMINE GOUIRI",
        number: 9,
        x: 400,
        y: 363,
        width: 140,
        portraitX: 4.999,
        size: 129.909,
        labelY: 103,
        labelH: 32,
        font: 20,
        numberX: 99.047,
        numberY: 5.208,
        numberW: 22,
        numberH: 26,
        numberFont: 20,
        numberFace: "Insatiable Display",
        markerX: 61.672,
        markerY: 141.106,
        markerSize: 16.655,
    },
    {
        image: "player-igor-paixao",
        name: "IGOR PAIXÃO",
        number: 14,
        x: 667,
        y: 248,
        width: 136.687,
        portraitX: 15.232,
        size: 106.079,
        labelY: 84.174,
        labelH: 26.256,
        font: 16.56546401977539,
        numberX: 89.473,
        numberY: 5.42,
        numberW: 24,
        numberH: 21,
        numberFont: 16.565,
        numberFace: "Insatiable Display",
        markerX: 61.543,
        markerY: 115.4,
        markerSize: 13.6,
    },
];
//# sourceMappingURL=lineups.js.map